
<div class="row">
    <div class="colIzquierda" ></div>
    <div class="divider" (mousedown)="onMouseDown($event)"></div>
    <div class="colDerecha"></div>
</div>

